import { ColumnDef } from "@tanstack/react-table";
import { formatMoneyCents } from "@/core/utils/money";
import { CustomerWithReferralsAndPayouts } from "@/customer/customer";

export const PayoutsCol = (): ColumnDef<CustomerWithReferralsAndPayouts> => ({
  id: "payouts_total",
  header: "Payouts",
  accessorFn: (row) =>
    formatMoneyCents(
      row.payouts.reduce((acc, payout) => acc + Number(payout.amount), 0),
    ) || "$0",
  cell: ({ getValue }) => (
    <span className="tabular-nums">{getValue() as string}</span>
  ),
  enableSorting: true,
});
